import { render } from "./TardyDetentionsTable.vue?vue&type=template&id=16cf95da"
import script from "./TardyDetentionsTable.vue?vue&type=script&lang=js"
export * from "./TardyDetentionsTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__